<template>
    <v-card>
        <!-- Summary -->
        <div class="d-flex align-center">
            <v-card-subtitle class="my-auto"
                >Cash details summary</v-card-subtitle
            >
            <v-spacer />
            <date-picker-button
                v-bind:date="cashDetails.date"
                v-on:date-change="onDateChange"
            />
        </div>
        <v-divider />
        <v-card-text>
            <v-simple-table dense>
                <tbody>
                    <tr>
                        <th class="text--secondary">
                            Cash transactions:
                        </th>
                        <td>
                            {{ cashtransactionsBalance | currency }}
                        </td>
                    </tr>
                    <tr>
                        <th class="text--secondary">
                            Cash orders:
                        </th>
                        <td>{{ cashOrdersTotal | currency }}</td>
                    </tr>

                    <tr>
                        <th>Total balance:</th>
                        <td>
                            <strong>{{
                                (cashOrdersTotal +
                                    Number(cashtransactionsBalance) +
                                    Number(courierTotalAdditionalExpense))
                                    | currency
                            }}</strong>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card-text>
        <!-- End Summary -->

        <v-container fluid v-if="null != cashDetails">
            <v-row>
                <!-- Transactions -->
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-subtitle class="d-flex align-baseline">
                            Cash transactions
                            <v-spacer />
                            <v-btn tile v-on:click="addCashtransaction">
                                Add
                            </v-btn>
                        </v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-card
                                class="mb-4"
                                v-for="cashtransaction in cashDetails.cashtransactions"
                                v-bind:key="cashtransaction.id"
                            >
                                <v-card-title>
                                    {{ cashtransaction.amount | currency }}
                                    <v-spacer />
                                    <small class="text--secondary">{{
                                        new Date(cashtransaction.datetime)
                                            | date('p')
                                    }}</small>
                                </v-card-title>
                                <v-card-subtitle>{{
                                    cashtransaction.description
                                }}</v-card-subtitle>
                                <v-divider />
                                <v-card-actions>
                                    <v-spacer />
                                    <v-icon
                                        class="mr-4"
                                        v-on:click="
                                            editCashtransaction(cashtransaction)
                                        "
                                        >mdi-pencil</v-icon
                                    >
                                    <v-icon
                                        class="mr-2"
                                        v-on:click="
                                            $emit(
                                                'request-delete-cashtransaction',
                                                cashtransaction
                                            )
                                        "
                                        >mdi-delete</v-icon
                                    >
                                </v-card-actions>
                            </v-card>
                            <v-card dark color="primary">
                                <v-card-subtitle class="pb-0"
                                    >Transactions balance:</v-card-subtitle
                                >
                                <v-card-subtitle class="py-0"
                                    >({{
                                        new Date(cashDetails.date)
                                            | date('dd-MMM-yyyy')
                                    }})</v-card-subtitle
                                >
                                <v-card-title>{{
                                    cashtransactionsBalance | currency
                                }}</v-card-title>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- End Transactions -->
                <!-- Orders -->
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-subtitle>Cash orders</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-card
                                class="mb-4"
                                v-for="cashOrder in cashDetails.cash_orders"
                                v-bind:key="cashOrder.id"
                            >
                                <v-card-title>
                                    {{ getCashOrderSum(cashOrder) | currency }}
                                    <v-spacer />
                                    <small class="text--secondary">{{
                                        new Date(cashOrder.completed_at)
                                            | date('p')
                                    }}</small>
                                </v-card-title>
                                <v-card-subtitle class="py-0"
                                    >Order ID:
                                    {{ cashOrder.id }}</v-card-subtitle
                                >
                                <template v-if="cashOrder.destination != null">
                                    <v-card-subtitle class="py-0"
                                        >Destination:
                                        {{
                                            cashOrder.destination
                                        }}</v-card-subtitle
                                    >
                                </template>
                                <v-card-subtitle class="pt-0">{{
                                    cashOrder.summary
                                }}</v-card-subtitle>
                            </v-card>
                            <v-card dark color="primary">
                                <v-card-subtitle class="pb-0"
                                    >Orders Total:</v-card-subtitle
                                >
                                <v-card-subtitle class="py-0"
                                    >({{
                                        new Date(cashDetails.date)
                                            | date('dd-MMM-yyyy')
                                    }})</v-card-subtitle
                                >
                                <v-card-title>{{
                                    cashOrdersTotal | currency
                                }}</v-card-title>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-subtitle>Additional Expenses</v-card-subtitle>
                        <v-divider />
                        <v-card-title>
                            <courier-additional-expense-list
                                :date="date"
                                :courierInfoId="courierinfo.id"
                        /></v-card-title>
                    </v-card>
                </v-col>
                <!-- End Orders -->
            </v-row>
            <cashtransaction-form-dialog
                v-model="showCashtransactionFormDialog"
                v-bind:cashtransaction="currentCashtransaction"
                v-bind:courierinfo="courierinfo"
                v-bind:date="cashDetails.date"
                v-on:request-save="
                    $emit('request-save-cashtransaction', $event)
                "
            />
        </v-container>
    </v-card>
</template>

<script>
export default {
    components: {
        'cashtransaction-form-dialog': () =>
            import('@/components/CashtransactionFormDialog.vue'),
        'date-picker-button': () => import('@/components/DatePickerButton.vue'),
        'courier-additional-expense-list': () =>
            import('@/components/CourierAddlExpenseList.vue')
    },
    props: {
        cashDetails: {
            type: Object,
            required: true
        },
        courierinfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            currentCashtransaction: {
                id: null,
                amount: 0,
                description: null
            },
            date: this.cashDetails.date,
            showCashtransactionFormDialog: false,
            courierTotalAdditionalExpense: 0.0
        };
    },
    computed: {
        cashOrdersTotal() {
            // Total the sum from each order
            return this.cashDetails.cash_orders.reduce(
                (accumulated, cashOrder) =>
                    accumulated + this.getCashOrderSum(cashOrder),
                0
            );
        },
        cashtransactionsBalance() {
            return this.cashDetails.cashtransactions.reduce(
                (accumulated, cashtransaction) =>
                    accumulated + Number(cashtransaction.amount),
                0
            );
        }
    },
    methods: {
        courierAdditionalExpenseCalculationAvailable(v) {
            console.log('courierAdditionalExpenseCalculationAvailable', v);
            if (v) {
                this.courierTotalAdditionalExpense = v;
            }
        },
        onDateChange($event) {
            this.date = $event;
            this.$emit('date-change', $event);
        },
        getCashOrderSum(cashOrder) {
            return (
                Number(cashOrder.restaurant_amount) +
                Number(cashOrder.service_charge)
            );
        },
        addCashtransaction() {
            this.currentCashtransaction = {
                id: null,
                amount: 0,
                description: null
            };
            this.showCashtransactionFormDialog = true;
        },
        editCashtransaction(cashtransaction) {
            // Assign a copy to avoid changing
            // the original cashtransaction in the dialog
            this.currentCashtransaction = { ...cashtransaction };
            this.showCashtransactionFormDialog = true;
        }
    }
};
</script>
